<template>
    <div class="collapse">
        <div v-if="title" class="title" v-html="title"></div>
        <div class="info" ref="description" :style="`height: ${collapse ? allHeight+'px' : height+'rem'}`">
            <div ref="info" v-html="content"></div>
        </div>
        <div class="more-info" @click="collapseFunc">
            {{ collapse ? '收起全部' : '查看全部' }}
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Collapse',
        props: {
            title: {
                type: String,
                default: ''
            },
            content: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                collapse: false,
                height:0.56,
                allHeight:0
            }
        },
        methods:{
            collapseFunc(){
                this.allHeight = this.$refs.info.offsetHeight;
                this.collapse = !this.collapse
            }
        },
        mounted() {
            this.allHeight = this.$refs.info.offsetHeight;
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .collapse {
        background: #fff;
        padding: 16px 16px;
        .title{
            color: #222222;
            margin-bottom: 16px;
            font-size: 19px;
        }
        .info{
            overflow: hidden;
            font-size: 15px;
            color: #222;
            line-height: 28px;
            background: #fff;
            transition: height .45s cubic-bezier(0.68, -0.55, 0.27, 1.55) 0s
        }
        .more-info{
            text-align: right;
            color: #F84025;
            font-size:15px;
            font-weight: normal;
            position: relative;
        }
    }
    .pack-up.collapse{
        .more-info:after{
            transform: rotate(135deg)
        }
    }
</style>